(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let smooth;
  const configure = () => {
    smooth?.destroy(); smooth = undefined;
    if (!reduced.matches && !window.Shopify?.designMode && window.Lenis) {
      smooth = new window.Lenis({autoRaf:true,duration:1.05,smoothWheel:true,syncTouch:false,anchors:true,allowNestedScroll:true,prevent:el=>Boolean(el.closest('dialog,[role="dialog"],.cart-drawer,.menu-drawer'))});
    }
  };
  configure(); reduced.addEventListener('change',configure);
  const updateClock = () => document.querySelectorAll('[data-nyc-clock]').forEach(el=>{el.textContent=new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false}).format(new Date());});
  updateClock(); const timer=setInterval(updateClock,1000);
  if (!reduced.matches && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.dataset.elyseaReveal='visible';observer.unobserve(entry.target);}}),{threshold:.05});
    document.querySelectorAll('.elysea-brand-intro,.elysea-based,.elysea-brand-material,.elysea-nyc__intro,.elysea-nyc figure,.elysea-section-heading').forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.dataset.elyseaReveal='pending';observer.observe(el);}});
    document.documentElement.classList.add('elysea-motion-ready');
    reduced.addEventListener('change',()=>{if(reduced.matches){observer.disconnect();document.querySelectorAll('[data-elysea-reveal]').forEach(el=>el.dataset.elyseaReveal='visible');}});
  }
})();
